import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { http, authHttp } from '@/api/http';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    try {
      const { data } = await http.get('/me'); // GET /api/me
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMe(); }, []);

  const logout = async () => {
    try {
      await authHttp.post('/logout'); // POST /logout (sin /api)
    } finally {
      setUser(null);
      localStorage.removeItem('loggedIn');
      window.location.replace('/login');
    }
  };

  const value = useMemo(() => ({ user, loading, fetchMe, logout }), [user, loading]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
